export function reservePublicNoticeSpace() {
    const body = document.body;
    const notice = document.getElementById('cookieNotice');
    if (!body?.classList.contains('dc-site') || !notice) return;

    const root = document.documentElement;
    const property = '--dc-cookie-notice-height';
    let active = true;
    const clear = () => {
        root.classList.remove('dc-cookie-space');
        root.style.removeProperty(property);
    };
    const measure = () => {
        if (!active || !notice.isConnected) return;
        const height = notice.getBoundingClientRect().height;
        if (!Number.isFinite(height) || height <= 0) return clear();
        root.style.setProperty(property, `${Math.ceil(height)}px`);
        root.classList.add('dc-cookie-space');
    };
    watchNotice(body, notice, measure, () => { active = false; clear(); });
    measure();
}

function watchNotice(body, notice, measure, clear) {
    const resize = window.ResizeObserver ? new window.ResizeObserver(measure) : null;
    if (resize) resize.observe(notice);
    else window.addEventListener('resize', measure);

    const removal = new MutationObserver(() => {
        if (notice.isConnected) return;
        clear();
        resize?.disconnect();
        window.removeEventListener('resize', measure);
        removal.disconnect();
    });
    removal.observe(body, { childList: true });
}
